import appMenu from "@/components/customized/com-app-menu";
	import {
		setElementLanguage
	} from "./language/index";
	import {
		listToRouter,
	} from "./js/common.js";
	export default {
		components: {
			appMenu
		},
		watch: {
		    $route(to,from){ 
				let e=this.$store.state.operate;
									if(e=='编辑'||e=='详情'||e=='删除'||e=='复制'||e=='添加'||e=='导入'||e=='导出'){
										 this.$store.commit("saveOperate", "");
										 this.$router.push({
										 	path: from.fullPath,
										 });
									}
				this.$store.commit("saveOperate", "");
				  
		      }
		   },
		data() { 
			return {
				isshow:true,
				logo: '/file/type/logos2.png', 
				menuOpen: false,
				routes: [],
				defaultFemalea: require('./assets/xiazs.jpg'),
				urls:''
			}
		},
		methods: {
			popoverShow(){
				if(this.urls)return;
					  this.urls=this.$domain+'/gh_6da949b80c46_258.jpg';
			},
			topersonalCenter(){
				this.$store.commit("saveMenu", {});
				this.$router.push({
					path: '/personal',
				});
			},
			witchRoleClick(e) {
				this.$axios.post('/api/Account/PostAccountRole',JSON.stringify(e.id.toString())).then(es => {
						let tree = listToRouter(es.data.list, ""); 
						localStorage.MODULE = JSON.stringify(es.data.list); 
						localStorage.ROUTER = JSON.stringify(tree);
						let user = JSON.parse(localStorage.USER);
						user.roleId=e.id;
						this.$store.commit("saveUser", user); 
						 this.$store.commit("saveMenu", {});
						  this.$store.commit("saveToken", es.data.owinToken.access_token);
						if (this.$route.path == '/') {
							location.reload()
						} else {
							this.$router.replace(
								this.$route.query.redirect ? this.$route.query.redirect : "/"
								
							);
							location.reload()
						}
				});
			},
			menuChange() {
				this.menuOpen = !this.menuOpen;
              this.logo=  this.menuOpen?'/file/type/logosas.png':'/file/type/logosa.png';
			},
			userInfo() {
				return typeof this.$store.state.user == 'string' ? JSON.parse(this.$store.state.user) : this.$store
					.state.user;
			},
			logout() { //退出登录
				this.$confirm(this.$t('app.logoutContent'), this.$t('app.logoutTitle'), {
					type: 'warning'
				}).then(() => {
					localStorage.clear();
					this.routes = [];
					this.$router.push('/login');
					location.reload()
				}).catch(() => {});
			},
			goIndex() {
				 this.$store.commit("saveMenu", {});
				this.$router.replace(
					this.$route.query.redirect ? this.$route.query.redirect : "/"
				);

			},
			setLanguage(lang) {
				let user = this.userInfo();
				this.$i18n.locale = lang;
				setElementLanguage(lang);
				this.$store.dispatch('setLanguage', lang);
				user.language = lang;
				this.$store.commit("saveUser", user);
			},
			pageReturn(){
				this.isshow=true;
				this.$store.commit("saveOperate", ""); 
			},
		},
		mounted() {
			
if(this.routes.length==0){
				let route = localStorage.ROUTER ?JSON.parse(localStorage.ROUTER):[];
				 let modules=localStorage.MODULE?JSON.parse( localStorage.MODULE):[];
				var params='?'+ (location.href.split("?")[1]||'');
				var name=location.pathname
				var index= modules.findIndex(item=>name.indexOf(item.path)>-1&&(item.params||'?')==params);
				if(index==-1&&route.length > 0&&this.$route.meta.path!="/"&&name!='/mp/error'&&name!='/mp/empty'){
					if(this.$route.path!="/"&&this.$route.path!="/login"){
					this.$router.replace(
						this.$route.query.redirect ? this.$route.query.redirect : "/"
					);
					}
				}
				if (route.length > 0) 
						this.routes = route;
				if(index>-1)
						this.$store.commit("saveMenu", modules[index]); 
			}
			var resizeTimer = null;
			let that=this;
			window.onresize = () => {
			        return (() => {
						 if (resizeTimer) clearTimeout(resizeTimer)
						        resizeTimer = setTimeout(function(){
								that.$store.commit("saveHeight", document.body.clientHeight); 
						        }, 1000);
			        })();
					};
		},
		updated() {
			if(this.routes.length==0){
				let route = localStorage.ROUTER ?JSON.parse(localStorage.ROUTER):[];
				if (route.length > 0) {
						this.routes = route;
				}
			}

		},
		computed: {
			stateLanguage() {
				return this.$store.state.language;
			},
			stateOperate(){
				return this.$store.state.operate;
			},
			getRoleName(){
					  return (this.$store.state.user.roleList.find(item=>{return item.id==this.$store.state.user.roleId})||{}).name||''
			},
		},
	}